// Copyright 2026, Imprivata, Inc. All rights reserved.

import { useEffect } from 'react';

import { useNavigateKeepSearch } from '@hooks/useNavigateKeepSearch';
import { RootRoutes } from '@/index';
import { featureSupported } from '@/featureFlagsUtils';
import { useSession } from '@/common/authorization/context/Session';
import { useSelfServiceData } from '@/self-service/utils/useSelfServiceData';
import { canEnrollOtp } from '@/self-service/utils/otpUtils';
import Otp from './Otp';
import AuthMethodLayout from '../AuthMethodLayout';

import OtpImg from '@assets/send_otp.svg';

const ENABLE_EMAIL_OTP = featureSupported('ENABLE_EMAIL_OTP');

const OtpRouteGuard = () => {
  const navigateKeepSearch = useNavigateKeepSearch();
  const { userInfo } = useSession();

  const { data: selfServiceLandingPageData, isLoading } = useSelfServiceData();

  const canAccess = canEnrollOtp({
    enableEmailOtp: ENABLE_EMAIL_OTP,
    email: userInfo?.email,
    userDisplayName: userInfo?.userDisplayName,
    authenticators: selfServiceLandingPageData?.authenticators,
  });

  useEffect(() => {
    if (!isLoading && !canAccess) {
      navigateKeepSearch(RootRoutes.SELF_SERVICE, { replace: true });
    }
  }, [canAccess, isLoading, navigateKeepSearch]);

  if (isLoading) {
    return null;
  }

  if (!canAccess) {
    return null;
  }

  return (
    <AuthMethodLayout
      graphic={
        <>
          <img src={OtpImg} alt="Desktop" className="left-panel-image-desktop" />
          <img src={OtpImg} alt="Mobile" className="left-panel-image-mobile" />
        </>
      }
    >
      <Otp />
    </AuthMethodLayout>
  );
};

export default OtpRouteGuard;
